import * as ActionName from '../action-names';
import InitialState from '../initial-state';

export default function appUIReducer(state = InitialState.getState().appUI, action) {

  switch (action.type) {
    case ActionName.SET_NATIVE_UX_VERSION:
      return Object.assign({}, state, { nativeUXVersion: action.value });
    case ActionName.KAMBI_CLIENT_RENDERED:
      return Object.assign({}, state, { isKambiLoaded: true });
    case ActionName.MOBILE_LOOK:
      return Object.assign({}, state, { isMobileLook: action.value });
    case ActionName.DEBUG_MODE:
      return Object.assign({}, state, { isDebugMode: action.value });
    default:
      return state;
  }
}
